export default "__VITE_ASSET__f55793d1__"